module.exports = __webpack_public_path__ + "bundle.css";


//////////////////
// WEBPACK FOOTER
// ./src/style.scss
// module id = 115
// module chunks = 0